module.exports = __webpack_public_path__ + "img/logo menu.06e9502c.png";